import * as React from "react";
import type { SVGProps } from "react";
const SvgGift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fillOpacity={0.2} clipPath="url(#gift_svg__a)">
      <path
        fill="#050033"
        d="M22.435 4.675h-1.747a2.8 2.8 0 0 0 .426-1.207c.138-1.384-.59-2.624-1.831-3.174a3.07 3.07 0 0 0-3.345.538l-2.205 2a2.34 2.34 0 0 0-3.468.002L8.056.832A3.07 3.07 0 0 0 4.711.294c-1.24.55-1.969 1.79-1.83 3.174.044.433.196.842.426 1.207H1.565C.701 4.675 0 5.375 0 6.24v2.348c0 .432.35.782.783.782h22.434c.433 0 .783-.35.783-.782V6.24c0-.865-.7-1.565-1.565-1.565M9.652 4.414v.26H5.97a1.544 1.544 0 0 1-1.495-1.919c.107-.446.43-.826.845-1.019a1.51 1.51 0 0 1 1.686.256L9.653 4.39zm9.909-1.154c-.059.813-.793 1.415-1.609 1.415h-3.604v-.289l2.605-2.362c.401-.363.962-.533 1.48-.378.745.222 1.182.855 1.128 1.614"
      />
      <path
        fill="#74758C"
        d="M1.565 10.936v11.478c0 .864.7 1.565 1.565 1.565h7.305V10.936zM13.565 10.936v13.043h7.304c.865 0 1.566-.7 1.566-1.565V10.935z"
      />
    </g>
    <defs>
      <clipPath id="gift_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGift;
